type OutletOptionTypes = {
	outlet_name: string;
	outlet_code: string;
	terminal?: string;
	location?: string;
};

const OutletOption = ({ outlet_name, outlet_code, terminal, location }: OutletOptionTypes) => {
	return <>{`${outlet_name} ${outlet_code} ${terminal} ${location ? location : ""}`}</>;
};

export default OutletOption;
